/* eslint-disable react-hooks/exhaustive-deps */
import { Spin, Timeline } from 'antd';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconEmpty from '../../../assets/Images/icons/empty';
import DPIAService from '../../../services/DPIA.service';
import InfiniteScroll from 'react-infinite-scroll-component';
import { statusSwitch } from '../ListDPIA';
import PreviewtoString from './PreviewToString';
import { useCallback } from 'react';

export default function History({ dpiaId, visible }) {
    const [histories, setHistories] = useState([]);
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    // const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);

    const getHistoryDPIA = useCallback(async (dpiaId) => {
        setLoading(true);
        const params = {
            dpiaId,
            p: page,
            ps: 100,
        };

        try {
            const { data } = await DPIAService.getHitoryByID(params);
            if (data?.resultData) {
                setHistories((histories) =>
                    histories.concat(data.resultData?.result)
                );
                setPage((page) => page + 1);
                // setTotal(data?.resultData?.total);
                setLoading(false);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }, []);

    useEffect(() => {
        if (!visible) {
            setHistories([]);
            setPage(1);
            // setTotal(0);
        }
    }, [visible]);

    useEffect(() => {
        getHistoryDPIA(dpiaId);
    }, [dpiaId]);

    return (
        <Timeline>
            <Spin spinning={loading}>
                <div
                    id="scrollableDiv"
                    className="h-[95vh] overflow-y-scroll p-4 pb-12"
                >
                    <InfiniteScroll
                        dataLength={histories.length}
                        next={() => getHistoryDPIA(dpiaId)}
                        hasMore={true}
                        scrollableTarget="scrollableDiv"
                        style={{ paddingTop: 5 }}
                        loader={<h4>Loading...</h4>}
                    >
                        {histories.length > 0 ? (
                            histories.map((item, i) => (
                                <Timeline.Item
                                    key={i}
                                    color={i === 0 ? '#F0536F' : '#3699FF'}
                                >
                                    <div
                                        className={classNames(
                                            'bg-[#EDEEF9] p-2 rounded-lg space-y-2',
                                            { 'bg-[#F4F6FC]': i !== 0 }
                                        )}
                                    >
                                        <div className="grid grid-cols-3 text-xs">
                                            <div className="col-span-1 font-semibold">
                                                {t('LogDate')} :
                                            </div>
                                            <div className="col-span-2">
                                                {item.logDate || '-'}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-3 text-xs">
                                            <div className="col-span-1 font-semibold">
                                                {t('Updated By')} :
                                            </div>
                                            <div className="col-span-2">
                                                {item.updateBy || '-'}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-3 text-xs">
                                            <div className="col-span-1 font-semibold">
                                                {t('Version')} :
                                            </div>
                                            <div className="col-span-2">
                                                {item.version || '-'}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-3 text-xs">
                                            <div className="col-span-1 font-semibold">
                                                {t('Action')} :
                                            </div>
                                            <div className="col-span-2">
                                                <span className="bg-purple-PHX px-2 rounded-xl text-white">
                                                    {item.action || '-'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-3 text-xs">
                                            <div className="col-span-1 font-semibold">
                                                {t('Status')} :
                                            </div>
                                            <div className="col-span-2">
                                                {statusSwitch(
                                                    t,
                                                    item.status === 'เสร็จสิ้น'
                                                        ? 'Done'
                                                        : ''
                                                ) || '-'}
                                            </div>
                                        </div>
                                        <DownloadFile item={item} />
                                    </div>
                                </Timeline.Item>
                            ))
                        ) : (
                            <div className="h-[30vh] grid items-center justify-center">
                                <div className="-mt-16">
                                    <IconEmpty />
                                </div>
                            </div>
                        )}{' '}
                    </InfiniteScroll>
                </div>
            </Spin>
        </Timeline>
    );
}

const DownloadFile = ({ item }) => {
    const { t } = useTranslation();
    const onClick = async (dpiaHistoryId) => {
        try {
            const { data } = await DPIAService.getHistoryDetail(dpiaHistoryId);
            if (data?.resultData) {
                const parse = JSON.parse(data?.resultData?.jsonData);
                const html = PreviewtoString(parse, item?.version);
                let blob = new Blob([html], {
                    type: 'text/html',
                });
                let url = URL.createObjectURL(blob);
                window.open(url);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="grid grid-cols-3 text-xs">
            <div className="col-span-1 font-semibold">
                {t('Download File')} :
            </div>
            <div className="col-span-2">
                <a
                    onClick={() => onClick(item.dpiaHistoryId)}
                    className="text-[#1890FF] underline"
                >
                    {t('Download document version')} {item.version}
                </a>
            </div>
        </div>
    );
};
